/**
 * BlockEventAgendaSectionItem
 * @param {Object} data, content data
 * @return {Object} normalized data
 */

export const mapperEventAgendaSectionItem = (data: any) => {
  if (!data) {
    return null
  }
  return {
    id: data.sys?.id || '',
    contentType: data.contentType,
    time: data.time || '',
    title: data.title || '',
    speaker: data.speaker || '',
    description: data.description || {}
  }
}
